module.exports = __webpack_public_path__ + "img/coupon-bg-icon-dis.1bfe5693.png";